module.exports = __webpack_public_path__ + "static/media/title-his.cfb5b8e7.png";